<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('property-fee-management')" v-if="permissionCodes.indexOf('040001000') !== -1">
        <i class="el-icon-damai-ic_wuyefeitaizhang"></i>
        <span slot="title">物业费台账</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('property-collection-fee')" v-if="permissionCodes.indexOf('040002000') !== -1">
        <i class="el-icon-damai-ic_wuyedaishoufeiyong"></i>
        <span slot="title">物业代收费用</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('temporary-parking-fee')" v-if="permissionCodes.indexOf('040003000') !== -1">
        <i class="el-icon-damai-ic_linshitingchefeiyong"></i>
        <span slot="title">临时停车费用</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('electricity-share-fee')" v-if="permissionCodes.indexOf('040005000') !== -1">
        <i class="el-icon-damai-ic_fentanyongdianfeiyong"></i>
        <span slot="title">分摊用电费用</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: ["property-fee-management","property-fee-management-add", "electricity-quota"],
  2: ["property-collection-fee"],
  3: ["temporary-parking-fee"],
  4: ["electricity-share-fee", "invoice-power-consumption"]
});

export default {
  name: "material-management-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/PropertyFee/PropertyFeeManagementNav.vue